import React from 'react';
import FasesConflitantes from './FasesConflitantes';

const corFases = {
  1: {
    cor: '#F44336',
    descricao: 'Vermelho',
  },
  2: {
    cor: '#FFEB3B',
    descricao: 'Amarelo',
  },
  3: {
    cor: '#68BC00',
    descricao: 'Verde',
  },
  4: {
    cor: '#b879d2',
    descricao: 'Vermelho Piscante',
  },
  5: {
    cor: '#FFFF99',
    descricao: 'Amarelo Piscante',
  },
  6: {
    cor: '#90EE90',
    descricao: 'Verde Piscante',
  },
};

const infoIntervalo = {
  1: {
    cor: '#38B0DE',
    abreviacao: 'P',
    descricao: 'Principal',
  },
  2: {
    cor: '#70DBDB',
    abreviacao: 'S',
    descricao: 'Secundário',
  },
  3: {
    cor: '#CD8C95',
    abreviacao: 'A',
    descricao: 'Atuado',
  },
  4: {
    cor: '#FFB5C5',
    abreviacao: 'SA',
    descricao: 'Sec.Alternativo',
  },
  5: {
    cor: '#5F9EA0',
    abreviacao: 'p',
    descricao: 'Adaptativo Coletivo',
  },
  6: {
    cor: '#808000',
    abreviacao: 'a',
    descricao: 'Atuado Adap. Coletivo',
  },
  7: {
    cor: '#006400',
    abreviacao: 'I',
    descricao: 'Adaptativo Individual',
  },
  8: {
    cor: '#98fb98',
    abreviacao: 'i',
    descricao: 'Atuado Adap. Individual',
  },
};

const camposIntervalo = {
  Mod: 'Modo',
  TpN: 'Tempo Normal',
  ND: 'Número do Detector',
  TpM: 'Tempo Mínimo',
  SL: 'Sequência Lógica',
  // 'Av+': 'Tempo de Variável', Solicitada remoção em 11/10/2024
  // AvM: 'Tempo Mínimo Variável', Solicitada remoção em 11/10/2024
  TE: 'Tempo Extensão', // Antes era TvE, solicitado para alterar para PE em 11/10/2024
  TME: 'Tempo Máximo de Extensão', // Antes era TvM, solicitado para alterar para PE em 11/10/2024
};

const corPiscante = {
  4: {
    descricao: 'Vermelho',
  },
  5: {
    descricao: 'Amarelo',
  },
};

const tipoFase = {
  1: {
    descricao: 'Veículo',
  },
  2: {
    descricao: 'Pedestre',
  },
};

function getCorFundoFases(descricao_tempo_minimo) {
  switch (descricao_tempo_minimo) {
    case 'tempo_amarelo_min':
      return '#FFEB3B';
    case 'tempo_verde_min':
      return '#68BC00';
    default:
      return '#f45555';
  }
}

// Função para calcular o ciclo total baseada na lógica do intervaloValidacao.js
function calculaCicloTotal(planoData) {
  if (!planoData || planoData.length === 0) return 0;

  const modoOperacaoId = parseInt(planoData[0].modo_operacao_id) || 0;
  let somaCiclo = 0.0;

  // Lógica para modo adaptativo
  if ([6, 7].includes(modoOperacaoId)) {
    const tpnRow = planoData.find(row => row.descricao === 'TpN');
    const tmeRow = planoData.find(row => row.descricao === 'TME');

    if (tpnRow) {
      for (const key in tpnRow) {
        if (key.startsWith('col_')) {
          somaCiclo += parseFloat(tpnRow[key]) || 0;
        }
      }
    }
    if (tmeRow) {
      for (const key in tmeRow) {
        if (key.startsWith('col_')) {
          somaCiclo += parseFloat(tmeRow[key]) || 0;
        }
      }
    }
    return somaCiclo.toFixed(1);
  }

  // Lógica original para os outros modos
  for (let index = 0; index < planoData.length; index++) {
    if (planoData[index].descricao === 'TpN') {
      for (const key in planoData[index]) {
        if (key.indexOf('col_') >= 0) {
          somaCiclo += parseFloat(planoData[index][key]) || 0;
        }
      }
    }
  }

  return somaCiclo.toFixed(1);
}

// Função para converter número para letra (1=A, 2=B, etc.)
function numeroParaLetra(numero) {
  return String.fromCharCode(64 + numero); // 64 + 1 = 65 (A)
}

// Função para formatar valor do ND (Número do Detector) - versão simplificada para relatório
function formatarND(valor, modoOperacaoId) {
  const val = parseInt(valor) || 0;
  if (val === 0) return '-';

  // Para o relatório, mostrar apenas o número formatado (não o texto descritivo)
  return String(val).padStart(3, '0');
}

// Função para formatar valores TE e TH (dividir por 10)
function formatarTE_TH(valor) {
  const val = parseFloat(valor) || 0;
  if (val === 0) return '-';
  return (val / 10).toFixed(1);
}

// Função para filtrar linhas baseado no modo de operação
function filtrarLinhasPorModo(planoData, modoOperacaoId) {
  return planoData.filter(row => {
    const descricao = row.descricao;

    // Linhas de fases e Mod aparecem em todos os modos
    if (descricao === 'Mod' || descricao.startsWith('F')) {
      return true;
    }

    if ([0, 3].includes(modoOperacaoId)) {
      // Modos Normal: Exclui ND, TE, TME, TH
      return !['ND', 'TE', 'TME', 'TH'].includes(descricao);
    } else if ([1, 4].includes(modoOperacaoId)) {
      // Modos Atuado: TpN, TpM, ND, TE, TME
      return ['TpN', 'TpM', 'ND', 'TE', 'TME'].includes(descricao);
    } else if ([2, 5].includes(modoOperacaoId)) {
      // Modos com Sequência Lógica: TpN, TpM, ND, SL, TE, TME
      return ['TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'].includes(descricao);
    } else if ([6, 7].includes(modoOperacaoId)) {
      // Modos Adaptativos: TpN, TpM, ND, TH, TE, TME
      return ['TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'].includes(descricao);
    }
    return false;
  });
}

// Função para ordenar linhas conforme a página principal
function ordenarLinhas(linhasExibidas, modoOperacaoId) {
  const fases = linhasExibidas
    .filter(row => row.descricao.startsWith('F'))
    .map(row => row.descricao)
    .sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));

  let desiredOrder = [];
  if ([1, 4].includes(modoOperacaoId)) {
    desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TE', 'TME'];
  } else if ([2, 5].includes(modoOperacaoId)) {
    desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'SL', 'TE', 'TME'];
  } else if ([6, 7].includes(modoOperacaoId)) {
    desiredOrder = ['Mod', ...fases, 'TpN', 'TpM', 'ND', 'TH', 'TE', 'TME'];
  } else {
    desiredOrder = ['Mod', ...fases, 'TpN', 'TpM'];
  }

  return linhasExibidas.sort((a, b) => {
    const indexA = desiredOrder.indexOf(a.descricao);
    const indexB = desiredOrder.indexOf(b.descricao);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });
}

const ANEIS_PADRAO_RELATORIO = [1, 2, 3, 4];

/** Exibe tempo na tabela de fases do PDF (evita células “vazias” por contraste ou valor ausente). */
function fmtTempoFaseRelatorio(v) {
  if (v === undefined || v === null || v === '') return '—';
  const n = Number(v);
  return Number.isFinite(n) ? String(n) : String(v);
}

const estCelulaTempoFase = tipo => ({
  border: '1px solid black',
  padding: '4px 6px',
  textAlign: 'center',
  backgroundColor: getCorFundoFases(tipo),
  color: '#111111',
  fontWeight: 700,
  WebkitPrintColorAdjust: 'exact',
});

function TabelaDetalheFasesRelatorio({ fases }) {
  if (!fases || fases.length === 0) {
    return <p style={{ fontSize: '13px', color: '#555' }}>Nenhuma fase cadastrada neste intervalo.</p>;
  }

  return (
    <table style={{ borderCollapse: 'collapse', width: '100%', maxWidth: '920px', justifyContent: 'center' }}>
      <thead>
        <tr>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Fase</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Monitora Vermelho</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Cor Piscante</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Latitude</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Longitude</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Tipo</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Quantidade</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Tempo mín. vermelho</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Tempo mín. amarelo</th>
          <th style={{ textAlign: 'right', paddingRight: '12px' }}>Tempo mín. verde</th>
        </tr>
      </thead>
      <tbody>
        {fases.map(fase => (
          <tr key={fase.id}>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>{fase.id}</td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
              {fase.ausencia_vermelho == 1 ? 'Sim' : 'Não'}
            </td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
              {corPiscante[fase.cor_piscante] ? corPiscante[fase.cor_piscante].descricao : fase.cor_piscante || ''}
            </td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>{fase.latitude}</td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>{fase.longitude}</td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
              {tipoFase[fase.tipo] ? tipoFase[fase.tipo].descricao : fase.tipo || ''}
            </td>
            <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>{fase.quantidade}</td>
            <td style={estCelulaTempoFase('tempo_vermelho_min')}>{fmtTempoFaseRelatorio(fase.tempo_vermelho_min)}</td>
            <td style={estCelulaTempoFase('tempo_amarelo_min')}>{fmtTempoFaseRelatorio(fase.tempo_amarelo_min)}</td>
            <td style={estCelulaTempoFase('tempo_verde_min')}>{fmtTempoFaseRelatorio(fase.tempo_verde_min)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function BlocoPlanoSegurancaAnel({ numAnel, bloco }) {
  if (!bloco || bloco.semCadastro) {
    return (
      <div style={{ marginBottom: '28px', pageBreakInside: 'avoid' }}>
        <h3 style={{ marginBottom: '10px' }}>{`Plano de segurança — Anel ${numAnel}`}</h3>
        <p style={{ fontSize: '13px', color: '#555' }}>Nenhum dado cadastrado para este anel.</p>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '32px', pageBreakInside: 'avoid' }}>
      <h3 style={{ marginBottom: '12px' }}>{`Plano de segurança — Anel ${numAnel}`}</h3>
      {bloco.infoConflito ? (
        <FasesConflitantes
          faseInicial={bloco.faseIni}
          faseFinal={bloco.faseFin}
          info_fases_conflitantes={bloco.infoConflito}
        />
      ) : (
        <p style={{ fontSize: '13px', color: '#555' }}>Sem matriz de conflitos para este anel.</p>
      )}
      <br />
      <TabelaDetalheFasesRelatorio fases={bloco.fases} />
    </div>
  );
}

const HtmlReport = ({
  planos,
  troca_planos,
  fases,
  info_fases_conflitantes,
  controlador,
  seguranca_por_anel,
  aneis_seguranca_relatorio,
}) => {
  let sIPControlador = planos[0][0].ip_controlador;
  let iPortaControlador = planos[0][0].porta;
  let iFaseInicial = planos[0][0].faseIni;
  let iFaseFinal = planos[0][0].faseFin;

  let sDescricaoControlador = `Controlador ${
    planos[0][0].numero_controlador
  } | IP: ${sIPControlador} | Porta: ${iPortaControlador}`;

  const cabecalhoRelatorioIdentificacao = (
    <>
      <h2>{sDescricaoControlador}</h2>
      {controlador && controlador.endereco && (
        <p style={{ margin: '4px 0 2px', fontSize: '14px', color: '#444' }}>
          {controlador.endereco}
          {controlador.cruzamento ? ` — ${controlador.cruzamento}` : ''}
        </p>
      )}
      <hr />
    </>
  );

  const listaAneisPlanoSegurancaPdf =
    Array.isArray(aneis_seguranca_relatorio) && aneis_seguranca_relatorio.length > 0
      ? aneis_seguranca_relatorio
      : ANEIS_PADRAO_RELATORIO;

  const secaoPlanoSegurancaRelatorioCabecalho =
    seguranca_por_anel != null ? (
      <>
        <h2 style={{ marginBottom: '18px' }}>Plano de segurança</h2>
        {listaAneisPlanoSegurancaPdf.map(numAnel => (
          <BlocoPlanoSegurancaAnel key={numAnel} numAnel={numAnel} bloco={seguranca_por_anel[numAnel]} />
        ))}
      </>
    ) : null;

  const diagramasPlanosHtml = planos.map((originalPlano, index) => {
          // Aplicar filtragem e ordenação baseada no modo de operação
          const modoOperacaoId = parseInt(originalPlano[0].modo_operacao_id) || 0;
          let aPlano = filtrarLinhasPorModo(originalPlano, modoOperacaoId);
          aPlano = ordenarLinhas(aPlano, modoOperacaoId);

          return (
            <div
              key={`diagrama-${index}`}
              className={`diagrama-plano-bloco ${index === 0 ? 'planos-first-div' : 'planos-other-div'}`}
              style={{
                pageBreakAfter: 'always',
                breakInside: 'avoid',
                pageBreakInside: 'avoid',
              }}
            >
              <div>
                <h3>{`Anel Nº ${originalPlano[0].numero_anel}: ${originalPlano[0].anel_descricao}`}</h3>
                <h3>{`${originalPlano[0].plano_descricao} - Modo de Operação: ${
                  originalPlano[0].modo_operacao_descricao
                }`}</h3>

                <br />

                <table style={{ borderCollapse: 'collapse', width: '40%' }}>
                  <tr>
                    <th />
                    {Array.from({ length: aPlano[0].numero_intervalo }, (_, index) => index + 1).map(index => (
                      <th>{numeroParaLetra(index)}</th>
                    ))}
                  </tr>

                  {aPlano.map((oPlano, linha) => (
                    <tr>
                      <th style={{ textAlign: 'right', paddingRight: '12px' }}>{oPlano.descricao}</th>

                      {Array.from({ length: aPlano[0].numero_intervalo }, (_, coluna) => coluna + 1).map(coluna =>
                        linha == 0 ? (
                          <>
                            {(() => {
                              const valorColuna = aPlano[linha][`col_${coluna}`];
                              const infoValida = infoIntervalo[valorColuna];

                              return (
                                <td
                                  style={{
                                    border: '1px solid black',
                                    padding: '2px',
                                    textAlign: 'center',
                                    backgroundColor: infoValida ? infoValida.cor : 'white',
                                  }}
                                >
                                  {infoValida ? infoValida.abreviacao : valorColuna || ''}
                                </td>
                              );
                            })()}
                          </>
                        ) : (
                          <>
                            <td
                              style={{
                                border: '1px solid black',
                                padding: '2px',
                                textAlign: 'center',
                                backgroundColor:
                                  oPlano.descricao.startsWith('F') &&
                                  corFases[aPlano[linha][`col_${coluna}`]] !== undefined
                                    ? corFases[aPlano[linha][`col_${coluna}`]].cor
                                    : 'white',
                              }}
                            >
                              {(() => {
                                const valor = aPlano[linha][`col_${coluna}`];
                                const descricao = oPlano.descricao;

                                if (descricao === 'ND') {
                                  return formatarND(valor, modoOperacaoId);
                                } else if (descricao === 'TE' || descricao === 'TH') {
                                  return formatarTE_TH(valor);
                                } else {
                                  // Para outras linhas que não são de fases, mostrar hífen se valor for 0
                                  if (!descricao.startsWith('F') && (valor == 0 || valor == '0')) {
                                    return '-';
                                  }
                                  return valor;
                                }
                              })()}
                            </td>
                          </>
                        ),
                      )}
                    </tr>
                  ))}
                </table>

                {/* Informações do Ciclo */}
                <div style={{ marginTop: '20px' }}>
                  <h4 style={{ marginBottom: '10px' }}>Informações do Ciclo</h4>
                  <table style={{ borderCollapse: 'collapse', width: '60%' }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: '1px solid black',
                            padding: '8px',
                            textAlign: 'center',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          Ciclo Total
                        </th>
                        <th
                          style={{
                            border: '1px solid black',
                            padding: '8px',
                            textAlign: 'center',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          Ciclo Máx.
                        </th>
                        <th
                          style={{
                            border: '1px solid black',
                            padding: '8px',
                            textAlign: 'center',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          Defasagem
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                          {calculaCicloTotal(originalPlano)}s
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                          {originalPlano[0].ciclo_maximo || 0}s
                        </td>
                        <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>
                          {originalPlano[0].defasagem || 0}s
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          );
  });

  return (
    <div style={{ WebkitPrintColorAdjust: 'exact' }}>
      {seguranca_por_anel != null ? (
        <>
          <div className="report-primeira-pagina-plano-seguranca">
            <div className="container-planos container-planos-primeira-pagina">
              {cabecalhoRelatorioIdentificacao}
              {secaoPlanoSegurancaRelatorioCabecalho}
            </div>
          </div>
          <div className="container-planos report-corpo-diagramas-planos">{diagramasPlanosHtml}</div>
        </>
      ) : (
        <div className="container-planos">
          {cabecalhoRelatorioIdentificacao}
          {diagramasPlanosHtml}
        </div>
      )}

      {troca_planos.length > 0 && (
        <>
          <div className="container-content" style={{ pageBreakAfter: 'always' }}>
            <h1 style={{ textAlign: 'center' }}>Tabela Troca de Planos</h1>

            <div className="tabela-troca-plano">
              <table style={{ borderCollapse: 'collapse', width: '40%', justifyContent: 'center' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Plano</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Domingo</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Segunda</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Terça</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Quarta</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Quinta</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Sexta</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Sábado</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Anel</th>
                    <th style={{ textAlign: 'right', paddingRight: '12px' }}>Horário</th>
                  </tr>
                </thead>

                {troca_planos.map((trocaPlano, index) => (
                  <>
                    <tbody>
                      <tr>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.plano_id}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.domingo == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.segunda == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.terca == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.quarta == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.quinta == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.sexta == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.sabado == 1 ? 'Sim' : 'Não'}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.anel}
                        </td>
                        <td style={{ border: '1px solid black', padding: '2px', textAlign: 'center' }}>
                          {trocaPlano.horario_inicial}
                        </td>
                      </tr>
                    </tbody>
                  </>
                ))}
              </table>
            </div>

            <br />
            <hr />

            {fases.length > 0 && seguranca_por_anel == null && (
              <>
                <h1 style={{ textAlign: 'center' }}>Fases</h1>
                <FasesConflitantes
                  faseInicial={iFaseInicial}
                  faseFinal={iFaseFinal}
                  info_fases_conflitantes={info_fases_conflitantes}
                />
                <br />
                <TabelaDetalheFasesRelatorio fases={fases} />
              </>
            )}
          </div>
        </>
      )}

      <br />
      <hr />

      <div className="container-content">
        <h1 style={{ textAlign: 'center' }}>Legendas</h1>
        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'flex-start', gap: '20px' }}>
          <div style={{ flex: 1, maxWidth: '45%', textAlign: 'center' }}>
            <h3>Fases</h3>
            <table style={{ borderCollapse: 'collapse', margin: 'left', width: '100%' }}>
              <tbody>
                {Object.keys(corFases).map(key => (
                  <tr key={key}>
                    <td
                      style={{
                        border: '1px solid black',
                        backgroundColor: corFases[key].cor,
                        textAlign: 'center',
                        width: '30%',
                      }}
                    >
                      {key}
                    </td>
                    <td style={{ border: '1px solid black', textAlign: 'left', paddingLeft: '3px', width: '70%' }}>
                      {corFases[key].descricao}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ flex: 1, maxWidth: '45%', textAlign: 'center' }}>
            <h3>Intervalos</h3>
            <table style={{ borderCollapse: 'collapse', margin: 'left', width: '100%' }}>
              <tbody>
                {Object.keys(infoIntervalo).map(key => (
                  <tr key={key}>
                    <td
                      style={{
                        border: '1px solid black',
                        backgroundColor: infoIntervalo[key].cor,
                        textAlign: 'center',
                        width: '30%',
                      }}
                    >
                      {infoIntervalo[key].abreviacao}
                    </td>
                    <td style={{ border: '1px solid black', textAlign: 'left', paddingLeft: '3px', width: '70%' }}>
                      {infoIntervalo[key].descricao}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ flex: 1, maxWidth: '45%', textAlign: 'center' }}>
            <h3>Campos Intervalo</h3>
            <table style={{ borderCollapse: 'collapse', margin: 'left', width: '100%' }}>
              <tbody>
                {Object.keys(camposIntervalo).map(key => (
                  <tr key={key}>
                    <td style={{ border: '1px solid black', textAlign: 'center', width: '30%' }}>{key}</td>
                    <td style={{ border: '1px solid black', textAlign: 'left', paddingLeft: '3px', width: '70%' }}>
                      {camposIntervalo[key]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HtmlReport;
